import { atom } from 'jotai'

export const userOnboardingModalAtom = atom({
  isOpen: false
})
